import React, { useContext } from 'react';
import styled, { css } from 'styled-components';
import { Tooltip } from '@ubeya/shared-web/components';
import { ReactComponent as BaseClientLikeIcon } from '@ubeya/shared-web/assets/heart-client-pink.svg';
import { ReactComponent as BaseClientUnLikeIcon } from '@ubeya/shared-web/assets/heart-client.svg';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const clientStatusIcon = css`
  width: 20px;
  height: 20px;
  cursor: pointer;
  transition: transform 0.2s;

  :hover {
    transform: scale(1.2);
  }
`;

const ClientLikeIcon = styled(BaseClientLikeIcon)`
  ${clientStatusIcon}

  circle {
    fill: ${({ theme }) => theme.colors.notification};
  }
`;

const ClientUnLikeIcon = styled(BaseClientUnLikeIcon)`
  ${clientStatusIcon}
`;

const PreferredEmployeeButton = ({ onChange, isPreferred, isThirdParty }) => {
  const { t, isAccountNetworkAccessSupplier } = useContext(ConfigContext);

  if (isAccountNetworkAccessSupplier || isThirdParty) {
    return <></>;
  }

  return (
    <Tooltip body={isPreferred ? t('clientUnmarkEmployeePreferredTooltip') : t('clientMarkEmployeePreferredTooltip')}>
      {isPreferred ? <ClientLikeIcon onClick={onChange} /> : <ClientUnLikeIcon onClick={onChange} />}
    </Tooltip>
  );
};

export default PreferredEmployeeButton;
